import { h, Component } from 'preact';
export default class About extends Component {
  render({}, {}) {
    return (
      <section class="about">
        <div class="about-image" />
        <div class="flex flex-middle">
          <h3 class="flex-auto">
            <span class="fa fa-user-circle">&nbsp;</span>
            About
          </h3>
          <div class="social-links">
            <a
              href="https://www.instagram.com/rosenthalfitness/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span class="fa fa-instagram" />
            </a>
            <a
              href="https://www.facebook.com/RosenthalFitness"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span class="fa fa-facebook" />
            </a>
          </div>
        </div>
        <p>Fitness is a crucial part of my life, I’d like to make it a part of yours too.</p>
        <p>I have had numerous years of experience in the fitness industry. Coupled with being an amateur athlete for many years, I know what it's like to have the support system of a guide, or a trainer, and how imperative it can be to one's success.</p>
        <p>My desire to learn about fitness for myself has propelled me forward in being able to help others improve and become better. You can read more about me and how and why I became a personal trainer below.</p>
        <h4>What's my purpose?</h4>
        <p>My purpose is to help you become better. Your fitness and health affects not only your physical abilities and looks but also your mental state and clarity.</p>
        <h4>What does it mean to become better?</h4>
        <p>It means that you realize your immense potential as a human being to do marvelous things and care for your body like the gift that it is.</p>
        <p>Becoming better physically, means that you can run, jump, skip, lift or pull without hesitation and without the risk of injury regardless of your age!</p>
        <h4>So why should you become better?</h4>
        <p>Why not?</p>
        <p>Get rid of that lingering tendonitis. shed those extra pounds. Gain more energy! I’d like to lend you a hand. I’d like to take you along with me on this journey of becoming better. You and me, together, becoming better.</p>
        <h4>Are you ready? Let's go!!!</h4>
        <h4>How did I get into personal training?</h4>
        <p>As a teenager I had a passion for martial arts. I always wanted to better myself. Become a stronger, more fierce, version of myself.</p>
        <p>As hard as I wanted to improve, I didn't have the guidance and proper instruction, so I had to improvise. I would train til exhaustion, the heavy bag, running, jump rope, you name it. But instead of improving I was slowly hurting myself.</p>
        <p>Daily i would put hours of hard work and sweat, but would not see any results, I was so frustrated. It was a disaster waiting to happen… And it did!</p>
        <p>I began having pains throughout my body,  limping, and was having a hard time walking for more than 10 minutes at a time. A jog or a hike seemed impossible. I was extremely lethargic.</p>
        <p>I felt that my body had betrayed me. I was angry!</p>
        <p>For two long years i was miserable.… full of anger and resentment toward everyone and their mother. My confidence was low. I couldn't bear to live like this! I had to do something.</p>
        <p>So I started researching my condition. I researched about doctors who could help me, some were instrumental and some less so. It took a while, but finally, with the right help, I figured out what was wrong with me -- it was called hip impingement.</p>
        <p>I ended up having a surgery. It helped quite a bit, but there was still pain and discomfort. And on top of it, now i was faced with the task of recovery.</p>
        <p>My recovery had to have been different than previously, I couldn't just go rogue again and expect a different result. This phase had to have been more thoughtful and diligent than my previous endeavours.</p>
        <p>So i started reading about proper ways of training and how the human body, and particularly muscles, work. Suddenly things were making sense. The more I studied, the more i understood why and how I got into this ditch at all, and how to get out of it.</p>
        <p>Since fitness has always been a passion of mine, and now having learned from my mistakes, I decided to become a personal trainer.</p>
        <p>As I continue learning and develop even further, I would like to share my knowledge and passion with others so that they don't have to go through the same painful lessons I had gone through. My job is to help others become better and lead a better life.</p>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/about.js